<div class="container">
  <ngx-spinner></ngx-spinner>

  <div class="search-form">
    <form (ngSubmit)="onSearch()" class="search-form">
      <div class="search-fields">
        <mat-form-field appearance="fill">
          <mat-label>Director Name</mat-label>
          <input matInput [(ngModel)]="searchForm.fullName" name="fullName" placeholder="Search by name" appTextNormalize>
        </mat-form-field>
      </div>

      <div class="search-actions">
        <button mat-flat-button color="primary" type="submit" [disabled]="!searchForm.fullName">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>
    </form>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2" [hidden]="!dataSource.data || dataSource.data.length === 0">
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Internal ID</th>
        <td mat-cell *matCellDef="let item">{{ item.code }}</td>
      </ng-container>

      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
        <td mat-cell *matCellDef="let item">{{ item.fullName }}</td>
      </ng-container>

      <ng-container matColumnDef="yearOfBirth">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Year of Birth</th>
        <td mat-cell *matCellDef="let item">{{ item.yearOfBirth }}</td>
      </ng-container>

      <ng-container matColumnDef="nationalityName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nationality</th>
        <td mat-cell *matCellDef="let item">{{ item.nationalityName }}</td>
      </ng-container>

      <ng-container matColumnDef="professionName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Profession</th>
        <td mat-cell *matCellDef="let item">{{ item.professionName }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-icon-button (click)="onConnect(item)">
            <mat-icon>{{ isSelected(item) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
          </button>
          <button mat-icon-button (click)="onOpenInNewTab(item, $event)"
                  matTooltip="Open the director in a new tab to check the CV">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'right-row': isSelected(row)}"></tr>
    </table>

    @if (!dataSource.data || dataSource.data.length === 0) {
      <div class="empty-state">
        No directors found. Please search to see results.
      </div>
    }

    <mat-paginator
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [hidden]="!dataSource.data || dataSource.data.length === 0"
      aria-label="Select page">
    </mat-paginator>
  </div>
</div>
